module.exports = __webpack_public_path__ + "static/img/cloudPrint.f95c3ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cloudPrint.png
// module id = 8xRI
// module chunks = 0